export const CREATE_CONTACT_ENDPOINT = '/booking-portal/ContactV2/CreateContact';
